import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';

import { AppRouter } from './router';
import { ProductMachineList } from './pages/Product/components/ProductMachineList';

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflowX: 'hidden',
    },
    content: {
        flex: 1,
        display: 'flex',
        overflowX: 'hidden',
    },
}));

function App(): React.ReactElement {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <AppRouter />
            </div>
        </div>
    );
}

export default App;
